// iOS (iPhone / iPad / iPod, 含 M 系列 Mac 的桌面版 Safari 偽裝) 偵測。
// App Store 上架時需隱藏 VIP / 訂閱 / 站外購買等字眼，各畫面請改用此共用函式。
export function isIOS() {
    if (typeof navigator === 'undefined') return false;
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}
